'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _createClass = require('@babel/runtime/helpers/createClass');
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var uniqBy = require('lodash/uniqBy.js');
require('./InputFile.js');
var utils = require('./utils.js');
require('@babel/runtime/helpers/extends');
require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
require('@chakra-ui/react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var uniqBy__default = /*#__PURE__*/_interopDefaultLegacy(uniqBy);
var isNonNullable = function isNonNullable(value) {
  return !!value;
};

/**
 * Utility functions for use in `useInputFile` hook and `File` component.
 * Provides functionality for unifying native files and custom types.
 */
var UseInputFileUtils = /*#__PURE__*/_createClass__default["default"]( /** If `true`, the component supports custom types. */

/** Function to normalize custom types to `AssetLike` objects. */

/** Function to check if a given value is a custom type. */

function UseInputFileUtils(normalizeCustomType, isCustomType) {
  var _this = this;
  _classCallCheck__default["default"](this, UseInputFileUtils);
  _defineProperty__default["default"](this, "supportsCustomTypes", void 0);
  _defineProperty__default["default"](this, "normalizeCustomType", void 0);
  _defineProperty__default["default"](this, "isCustomType", void 0);
  _defineProperty__default["default"](this, "unique", function (files) {
    return uniqBy__default["default"](files.filter(isNonNullable), function (file) {
      return _this.computeKey(file);
    });
  });
  _defineProperty__default["default"](this, "toFileList", function (files) {
    var dataTransfer = new DataTransfer();
    if (!(files !== null && files !== void 0 && files.length)) return new DataTransfer().files;
    files.filter(utils.isNativeFile).forEach(function (file) {
      dataTransfer.items.add(file);
    });
    return dataTransfer.files;
  });
  _defineProperty__default["default"](this, "add", function () {
    var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return _this.unique([].concat(_toConsumableArray__default["default"](to || []), _toConsumableArray__default["default"](files)));
  });
  _defineProperty__default["default"](this, "remove", function (fileOrIndex, from) {
    if (typeof fileOrIndex === 'number') {
      return from.filter(function (_, index) {
        return index !== fileOrIndex;
      });
    }
    return from.filter(function (file) {
      return file !== fileOrIndex;
    });
  });
  _defineProperty__default["default"](this, "computeKey", function (file) {
    var assetLike = _this.computeAssetLike(file);
    return [assetLike.filename, Date.now()].filter(Boolean).join('-');
  });
  _defineProperty__default["default"](this, "computeAssetLike", function (file) {
    var _isNativeFile = utils.isNativeFile(file);
    var _isCustomType = _this.isCustomType(file);
    if (_isCustomType) {
      return _this.normalizeCustomType(file);
    }
    if (_isNativeFile) {
      return {
        title: file.name,
        byteSize: file.size,
        filename: file.name,
        contentType: file.type
      };
    }
    throw new Error("File or custom type expected, got ".concat(JSON.stringify(file), " (isNativeFile: ").concat(_isNativeFile, ", isCustomType: ").concat(_isCustomType, ")"));
  });
  this.supportsCustomTypes = !!normalizeCustomType && !!isCustomType;
  this.normalizeCustomType = normalizeCustomType;
  this.isCustomType = isCustomType;
}

/**
 * Remove duplicate files from an array of files.
 * @param files
 */);

exports.UseInputFileUtils = UseInputFileUtils;